import { render, staticRenderFns } from "./RasConfigurazionePostiLettoStanzeListComponent.vue?vue&type=template&id=0acbe433"
import script from "./RasConfigurazionePostiLettoStanzeListComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoStanzeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports